module.exports = __webpack_public_path__ + "img/中房网.d939b2fa.png";